import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen flex flex-col bg-white text-[#0A0A0A]" data-id="element-84">
      <Header data-id="element-85" />
      <main className="flex-grow pt-[88px]" data-id="element-86">{children}</main>
      <Footer data-id="element-87" />
    </div>;
}